import { createContext } from 'react';

const authContext = createContext();

export { authContext as default };